import React from 'react'
import SuspenseLoading from '@components/SuspenseLoading'
import Card from '@components/V3/Card'
import useOrder from '@page-components/TrackV2/hooks/useOrder.main'
import dynamic from 'next/dynamic'

const PendingPaymentRequestInner = dynamic(() => import('./PendingPaymentRequestInner'))

export default function PendingPaymentRequests() {
  const {order} = useOrder()

  if (!order.pendingPaymentRequests?.length) return null

  return (
    <Card transparentOnDesktop desktopThreshold="lg">
      <SuspenseLoading>
        <PendingPaymentRequestInner />
      </SuspenseLoading>
    </Card>
  )
}
